/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { TextField, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function CustomTextarea({ value, limit, helperText, hasLimitCounter, ...props }) {
  const classes = useStyles();
  const symbolsCountClasses = cn(classes.symbolsCount, { [classes.symbolsCountWithHelper]: helperText });

  return (
    <div className={classes.textarea}>
      <TextField
        data-testid="textarea-field"
        inputProps={{ maxLength: limit }}
        defaultValue={value}
        variant="outlined"
        margin="normal"
        color="primary"
        rows={4}
        fullWidth
        multiline
        helperText={helperText}
        {...props}
      />
      {hasLimitCounter && (
        <Typography className={symbolsCountClasses} variant="caption" gutterBottom>
          {`${value.length}/${limit}`}
        </Typography>
      )}
    </div>
  );
}

CustomTextarea.propTypes = {
  value: PropTypes.string,
  helperText: PropTypes.string,
  limit: PropTypes.number,
  hasLimitCounter: PropTypes.bool,
  ...TextField.propTypes,
};

CustomTextarea.defaultProps = {
  helperText: '',
  value: '',
  limit: 100,
  hasLimitCounter: true,
};

export default CustomTextarea;
